/**
 *
 * @/services/endpoints/users.js
 *
 */

//
// IMPORTS
//

import { httpGet } from '@/services/api/http'
import { getUserUID } from '@/services/endpoints/session'
import { version, PARTNER } from '@/constants'

//
//
//

// --- INFORMAÇÕES DOS USUÁRIOS

// Lista de usuários da escala usado no ADICIONAR USUÁRIO NA ESCALA do EDITAR ESCALA
export const apiGetUserListByScale = (groupID, scaleID, ifModifiedSince) => httpGet({ route: `api/v1/groups/${groupID}/scales/${scaleID}/users`, headers: { "Client": "WEB", "Partner": PARTNER, "X-App-Version": version, "User-ID": getUserUID(), "If-Modified-Since": ifModifiedSince } })
